import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import Tags from "./Tags";
import "../styles/components/tag-input.scss";
import { Row } from "antd";
import ic_warning from "../assets/images/ic-warning.svg";
import * as R from "ramda";

class TagInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
    };
  }
  addTag = () => {
    if (!this.props.deactive && this.state.value) {
      this.props.addTag(this.props.type, {
        id: this.state.value,
        value: {
          value: this.state.value,
          is_verified: false,
        },
      });
      this.setState(() => ({ value: "" }));
    }
  };

  addTagKeyPress = (e) => {
    if (e.key === "Enter") {
      this.addTag();
    }
  };

  inputChange = (e) => {
    const value = e.target.value;
    this.setState(() => ({
      value,
    }));
  };

  removeTag = (id) => {
    if (!this.props.deactive) {
      this.props.removeTag(this.props.type, id);
    }
  };
  hasUnVerifiedTag = (list = []) => {
    let b = false;
    list.map((v) => {
      if (!v.value.is_verified) {
        b = true;
      }
    });
    return b;
  };
  render() {
    const getBotData = () => {
      let botData = {
        id: "",
        link: "",
      };
      botData.id = "updamusalertbot";
      if (this.props.label === "Telegram") {
        botData.link = "https://t.me/" + botData.id;
      }
      return botData;
    };
    const isWebhook = this.props.type === "webhooks";
    return (
      <div className="tag-input">
        <div
          className={`tag-input__input__container ${
            isWebhook ? "webhook" : ""
          }`}
        >
          <div className="tag-header">
            <img src={this.props.tagIcon} alt="Tag Icon" />
            <p>{this.props.label}</p>
            {!getBotData().link.length <= 0 && (
              <a
                href={getBotData().link}
                className="button-start-bot"
                target="_blank"
                rel="noopener noreferrer"
              >
                Start Bot
              </a>
            )}
          </div>
          <div className="tag-input__input">
            {isWebhook ? (
              <textarea
                type="text"
                value={this.state.value}
                onChange={this.inputChange}
                onKeyPress={this.addTagKeyPress}
                placeholder={this.props.placeHolder}
              />
            ) : (
              <input
                type="text"
                value={this.state.value}
                onChange={this.inputChange}
                onKeyPress={this.addTagKeyPress}
                placeholder={this.props.placeHolder}
              />
            )}

            <button type="button" onClick={this.addTag}>
              <PlusOutlined />
            </button>
          </div>
        </div>
        {this.props.unVerifiedTagDesc !== undefined &&
          this.hasUnVerifiedTag(this.props.tags) && (
            <Row gutter={32} className="tag-input__tags unVerifiedTagDesc">
              <img src={ic_warning} alt="warning Icon" />
              <p>{this.props.unVerifiedTagDesc}</p>
            </Row>
          )}

        <Tags
          tags={this.props.tags}
          color={this.props.color}
          removeTag={this.removeTag}
          tagIndicator={this.props.tagIndicator}
          isWebhook={isWebhook}
          channel_type={this.props.channel_type}
        />
      </div>
    );
  }
}

export default TagInput;
